import { useMemo } from 'react';
import { Role } from '../enums/Role';
import { checkRoleAccess } from '../utils/RoleUtil';
import { useGetBackofficeRoles } from './useGetBackofficeRoles';

export const useCheckBackofficeRoles = (allowedRoles: Role[]) => {
  const userRoles = useGetBackofficeRoles();
  return useMemo(() => checkRoleAccess(allowedRoles, userRoles), [allowedRoles, userRoles])
}